import styles from './Separator.module.scss';

import clsx from 'clsx';
import React from 'react';

interface ISeparatorProps {
  classes?: {
    wrapper?: string;
    separator?: string;
  };
}

export const Separator: React.FC<ISeparatorProps> = (props) => {
  const { classes, ...rest } = props;

  return (
    <div className={clsx(styles.wrapper, classes.wrapper)} {...rest}>
      <div className={clsx(styles.separator, classes.separator)} />
    </div>
  );
};
